import type { Treatment } from '../types/treatment';

export const mockMassages: Treatment[] = [
  {
    date: '2024-03-20',
    time: '10:00 - 11:00',
    type: 'Ayurveda Massage',
    therapist: 'Maria Schmidt',
    room: 'Behandlung 1',
    status: 'confirmed'
  },
  {
    date: '2024-03-22',
    time: '14:00 - 15:00',
    type: 'Thai Massage',
    therapist: 'Thomas Müller',
    room: 'Behandlung 2',
    status: 'pending'
  }
];

export const mockYogatherapy: Treatment[] = [
  {
    date: '2024-03-21',
    time: '09:00 - 10:00',
    type: 'Initial Consultation',
    therapist: 'Dr. Anna Weber',
    room: 'Therapie 1',
    status: 'confirmed'
  },
  {
    date: '2024-03-23',
    time: '11:00 - 12:00',
    type: 'Follow-up Session',
    therapist: 'Dr. Anna Weber',
    room: 'Therapie 1',
    status: 'confirmed'
  }
];